import { RECOMMENDATION_TYPES } from '@bingads-webui-campaign/recommendation-core';

export const OTHER_REASON = 'Other';

export const FEEDBACK_LOOP_REASON_TABLE = {
  [RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY]: [
    'NoBudget',
    'OtherTech',
    'NotImprove',
    'DoLater',
    'Unclear',
    OTHER_REASON,
  ],
};

export const REASON_TABLE = {
  default: [
    'NotInterested',
    'OtherSolution',
    'DoNotUnderstand',
    'NotApplicable',
    'SpendNoMore',
    OTHER_REASON,
  ],
  [RECOMMENDATION_TYPES.FIX_AD_TEXT]: [
    'FixAdContWIP',
    'FixAdContWontFix',
    'FixAdContResolveOutsideAds',
    'FixAdContOther',
  ],
  [RECOMMENDATION_TYPES.FIX_AD_DESTINATION]: [
    'FixAdContWIP',
    'FixAdContWontFix',
    'FixAdContResolveOutsideAds',
    'FixAdContOther',
  ],
  [RECOMMENDATION_TYPES.SETUP_CONVERSION_TRACKING_OPPORTUNITY]: [
    'SetupConvDoItLater',
    'SetupConvNeedAssistance',
    'SetupConvWorking',
    'SetupConvCannotMakeChanges',
    'SetupConvUseOtherTool',
    'SetupConvNotRelevant',
    'SetupConvOther',
  ],
  [RECOMMENDATION_TYPES.FIX_CONVERSION_TRACKING_OPPORTUNITY]: [
    'FixConvFixItLater',
    'FixConvNeedAssistanceToFix',
    'FixConvWorkInProgress',
    'FixConvNotInUse',
    'FixConvOther',
  ],
  [RECOMMENDATION_TYPES.FIX_CONVERSION_GOAL_SETTINGS]: [
    'FixConvGoalFixItLater',
    'FixConvGoalCurrentSettingCorrect',
    'FixConvGoalNeedAssistanceToFix',
    'FixConvGoalAlreadyFixed',
    'FixConvGoalGoalNotUse',
    'FixConvGoalOther',
  ],
  [RECOMMENDATION_TYPES.REPAIR_ADS]: [
    'RepairAdsAlreadyAddressed',
    'RepairAdsPendingEditorial',
    'RepairAdsDsaAsSearch',
    'RepairAdsIntentional',
    'RepairAdsAddressOutside',
    'RepairAdsOther',
  ],
  [RECOMMENDATION_TYPES.REPAIR_KEYWORD]: [
    'RepairKeywordsAlreadyAddressed',
    'RepairKeywordsPendingEditorial',
    'RepairKeywordsDsaAsSearch',
    'RepairKeywordsIntentional',
    'RepairKeywordsAddressOutside',
    'RepairKeywordsOther',
  ],
  [RECOMMENDATION_TYPES.MULTIMEDIA_ADS]: [
    'MmaNotInterested',
    'MmaOtherTools',
    'MmaNotUnderstand',
    'MmaNotApplicable',
    'MmaNotQualified',
    'MmaOther',
  ],
  [RECOMMENDATION_TYPES.CREATE_CONVERSION_GOAL]: [
    'CreateConvGoalCreateItLater',
    'CreateConvGoalNotInterested',
    'CreateConvGoalGoalTypeNotMatched',
    'CreateConvGoalAlreadyExist',
    'CreateConvGoalInappropriateSuggestion',
    'CreateConvGoalOther',
  ],
  [RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS]: [
    'RsaAddRecommendedAdsLater',
    'RsaNoAutoGeneratedAssets',
    'RsaNeedApprovalBeforeApply',
    'RsaNeedOptOutAAR',
    OTHER_REASON,
  ],
  [RECOMMENDATION_TYPES.IMAGE_EXTENSION]: [
    'ImageAdExtNotInterested',
    'ImageAdExtNotApplicable',
    'ImageAdExtPerformedNotWell',
    'ImageAdExtOther',
  ],
  [RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS]: [
    'FixRepairMissingKeywordParamsFixItLater',
    'FixRepairMissingKeywordParamsNotKnowingWhyFix',
    'FixRepairMissingKeywordParamsNotSignificant',
    'FixRepairMissingKeywordParamsOther',
  ],
  [RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID]: [
    'FixNoImpressionBidSuggestTooHigh',
    'FixNoImpressionBidSuggestNotSignificant',
    'FixNoImpressionBidAdjustLater',
    'FixNoImpressionBidHaveAdjusted',
    'FixNoImpressionBidManagedByAgency',
    'FixNoImpressionBidOther',
  ],
  [RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS]: [
    'FixImproveResponsiveSearchAdsManagedByMyself',
    'FixImproveResponsiveSearchImprovementLater',
    'FixImproveResponsiveSearchAdsNotSignificant',
    'FixImproveResponsiveSearchAdsNotUnderstand',
    'FixImproveResponsiveSearchAdsOther',
  ],
  [RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER]: [
    'FixRepairUntargetedOfferNotRelevant',
    'FixRepairUntargetedOfferManageInconvenient',
    'FixRepairUntargetedOfferExcludedIntentionally',
    'FixRepairUntargetedOfferNotUnderstand',
    'FixRepairUntargetedOfferImprovementLater',
    'FixRepairUntargetedOfferOther',
  ],
  [RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS]: [
    'ImproveMultiMediaAdsManagedByMyself',
    'ImproveMultiMediaAdsNotSignificant',
    'ImproveMultiMediaAdsCostTooHigh',
    'ImproveMultiMediaAdsNotUnderstand',
    'ImproveMultiMediaAdsOther',
  ],
  [RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION]: [
    'DSA2PMaxMigrationNoApplyUntilAttributesReviewed',
    'DSA2PMaxMigrationUnsureRecommendedCampaignIsImprovement',
    'DSA2PMaxMigrationCreatePerformanceMaxCampaignByMyOwn',
    'DSA2PMAxMigrationOther',
  ],
  [RECOMMENDATION_TYPES.SYNDICATION_GAP]: [
    'SyndicationGapAdPerfLowerThanExpected',
    'SyndicationGapOnlyDisplayedOnMicrosoftSitesSelected',
    'SyndicationGapOther',
  ],
};

export const REASON_TABLE_NEW_I18N = {
  [RECOMMENDATION_TYPES.REPAIR_MISSING_KEYWORD_PARAMS]: {
    FixRepairMissingKeywordParamsFixItLater: _TL_('I will fix this issue later.'),
    FixRepairMissingKeywordParamsNotKnowingWhyFix: _TL_('I don\'t understand why I should fix this issue.'),
    FixRepairMissingKeywordParamsNotSignificant: _TL_('The estimates show no significant improvement.'),
    FixRepairMissingKeywordParamsOther: _TL_('Other'),
  },
  [RECOMMENDATION_TYPES.FIX_NO_IMPRESSION_BID]: {
    FixNoImpressionBidSuggestTooHigh: _TL_('The suggested bids are higher than expected.'),
    FixNoImpressionBidSuggestNotSignificant: _TL_('The suggestion shows no significant improvement.'),
    FixNoImpressionBidAdjustLater: _TL_('I will adjust the bid later.'),
    FixNoImpressionBidHaveAdjusted: _TL_('I have recently adjusted the bid.'),
    FixNoImpressionBidManagedByAgency: _TL_('This account is managed by an agency.'),
    FixNoImpressionBidOther: _TL_('Other'),
  },
  [RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS]: {
    FixImproveResponsiveSearchAdsManagedByMyself: _TL_('I will manage the assets in responsive search ads by myself.'),
    FixImproveResponsiveSearchImprovementLater: _TL_('I will make the improvement later.'),
    FixImproveResponsiveSearchAdsNotSignificant: _TL_('The performance of responsive search ads show no significant improvement.'),
    FixImproveResponsiveSearchAdsNotUnderstand: _TL_('I don\'t understand the recommendation.'),
    FixImproveResponsiveSearchAdsOther: _TL_('Other'),
  },
  [RECOMMENDATION_TYPES.REPAIR_UNTARGETED_OFFER]: {
    FixRepairUntargetedOfferNotRelevant: _TL_('The suggested campaigns do not align with my business goal.'),
    FixRepairUntargetedOfferManageInconvenient: _TL_('Managing a catch-all campaign is inconvenient.'),
    FixRepairUntargetedOfferExcludedIntentionally: _TL_('I want to exclude some product offers from my shopping campaign.'),
    FixRepairUntargetedOfferNotUnderstand: _TL_('I don\'t know why this has been recommended to me.'),
    FixRepairUntargetedOfferImprovementLater: _TL_('I\'ll create a catch-all shopping campaign later.'),
    FixRepairUntargetedOfferOther: _TL_('Other'),
  },
  [RECOMMENDATION_TYPES.IMPROVE_MULTIMEDIA_ADS]: {
    ImproveMultiMediaAdsManagedByMyself: _TL_('I\'ll manage the ad texts, headlines, and images in Multimedia ads.'),
    ImproveMultiMediaAdsNotSignificant: _TL_('The recommendation doesn\'t improve my multimedia ad performance.'),
    ImproveMultiMediaAdsCostTooHigh: _TL_('The estimated cost is too high.'),
    ImproveMultiMediaAdsNotUnderstand: _TL_('The recommendation is unclear.'),
    ImproveMultiMediaAdsOther: _TL_('Other'),
  },
  [RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION]: {
    DSA2PMaxMigrationNoApplyUntilAttributesReviewed: _TL_('I don\'t want to apply the recommendation unless I can review the recommended attributes for the Performance Max campaign.'),
    DSA2PMaxMigrationUnsureRecommendedCampaignIsImprovement: _TL_('I\'m unsure that the recommended campaign will be an improvement.'),
    DSA2PMaxMigrationCreatePerformanceMaxCampaignByMyOwn: _TL_('I\'ll create my own Performance Max campaign.'),
    DSA2PMAxMigrationOther: _TL_('Other'),
  },
  [RECOMMENDATION_TYPES.SYNDICATION_GAP]: {
    SyndicationGapAdPerfLowerThanExpected: _TL_('My ad performance was lower than expected on the Microsoft Advertising Network.'),
    SyndicationGapOnlyDisplayedOnMicrosoftSitesSelected: _TL_('My ads can only be displayed on Microsoft sites and select traffic.'),
    SyndicationGapOther: _TL_('Other'),
  },
};

export const NAVIGATE_REASON = {
  // for certain feedback reason, it would trigger naviagte
  // modal so that help user navigate to detail page of certain
  // recommendation
  NoBudget: 'NoBudget',
  BudgetNoBudget: 'BudgetNoBudget',
};

export const RECOMMENDATION_DISMISS_ALL_MT_REASONID_CONFIGS = {
  [RECOMMENDATION_TYPES.BUDGET_OPPORTUNITY]: {
    excludedReason: [OTHER_REASON],
    prefix: 'Budget',
  },
};

export const COMMENT_ONLY_REASON_LIST = [
  'FixConvGoalGoalNotUse',
];

export const COMMENT_WITH_URL_REASON_LIST = [
  'FixConvGoalNeedAssistanceToFix',
];

export const URL_FOR_COMMENT_WITH_URL_REASON_LIST = {
  [COMMENT_WITH_URL_REASON_LIST.FixConvGoalNeedAssistanceToFix]: 'http://go.microsoft.com/fwlink/?LinkId=258669',
};

export const RECOMMENDATION_REASON_TO_COMMENT_TRANSLATOR = {
  BudgetTooHigh: 'Recommendation_Feedback_Reason_BudgetHigh_Comment',
  BudgetCpcTooHigh: 'Recommendation_Feedback_Reason_CPCHigh_Comment',
  RecommendedBudgetHigh: 'Recommendation_Feedback_Reason_BudgetHigh_Comment',
  CPCHigh: 'Recommendation_Feedback_Reason_CPCHigh_Comment',
  FixConvGoalNeedAssistanceToFix: 'Recommendation_Dismiss_Feedback_NeedAssistanceToFix_Comment',
  FixConvGoalGoalNotUse: 'Recommendation_Dismiss_Feedback_GoalNotUse_Comment',
};
